import {navigate} from "gatsby"
import {gsap} from "gsap";


class customNav {
    constructor() {
        this.info ='Navigazione generale';
        this.tl = new gsap.timeline();
    }
    nav(target) {

        if (window.location.pathname === target) {
            return false
        } else {

        }

        this.tl
        .add('start')

        .to('main', {
            duration: 0.5,
            opacity: 0
        },'start')
        .to('.site__canvas-wrap', {
            duration: 0.5,
            opacity: 0,
        },'start')
        .add(function () {
            window.ss.destroy();
            window.ss.init();
            navigate(target);
        })
        .add('end')
        .add(function () {
            console.log('navigation - change page');
            window.dispatchEvent(new Event('resize'));
        },'end+=.25');

    }
}

export default customNav